exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anchor-container{\r\n    overflow-y: auto;\r\n    max-height: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/anchor/anchor.component.css
// module id = ../../../../../src/app/components/utils/dynamic/components/anchor/anchor.component.css
// module chunks = main